<template>
  <section id="partners" class="py-16 md:py-24 bg-gray-800 bg-opacity-50">
    <div class="container mx-auto px-4 sm:px-6 lg:px-8">
      <h2 class="text-3xl md:text-4xl font-bold text-center text-white mb-12 md:mb-16" data-aos="fade-up">
        {{ $t('partners.title') }}
      </h2>
      <swiper :modules="[Autoplay]" :slides-per-view="2" :space-between="30" :autoplay="{
        delay: 2500,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      }" :loop="true" :centered-slides="true" :breakpoints="{
        640: { slidesPerView: 3, spaceBetween: 30 },
        768: { slidesPerView: 4, spaceBetween: 40 },
        1024: { slidesPerView: 5, spaceBetween: 50 },
      }" class="h-24" data-aos="fade-up" data-aos-delay="100">
        <swiper-slide v-for="(partner, index) in partners" :key="partner.name + '-' + index"
          class="flex items-center justify-center">
          <img :src="partner.logoUrl" :alt="partner.name"
            class="max-h-16 w-auto object-contain transition-all duration-300 opacity-40 hover:opacity-100"
            :class="{ 'filter grayscale hover:grayscale-0 opacity-70': partner.name !== 'X' }" />
        </swiper-slide>
      </swiper>
    </div>
  </section>
</template>

<script setup lang="ts">
import { Autoplay } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/vue'
import { ref } from 'vue'

const originalPartners = [
  { name: 'Google', logoUrl: 'partnerLogos/google.png' },
  { name: 'Deep Seek', logoUrl: 'partnerLogos/deepseek.png' },
  { name: 'Meta', logoUrl: 'partnerLogos/meta.png' },
  { name: 'X', logoUrl: 'partnerLogos/x.png' },
  { name: 'Google Ads', logoUrl: 'partnerLogos/ads.png' },
];

const partners = ref([...originalPartners, ...originalPartners]);
</script>

<style scoped>
.swiper-slide img {
  max-height: 6rem;
}

.swiper-slide {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
